import appConfig from "../../config";
import { getLocalStorageInfo } from "../../utils_v2";
export const recordsCategory = {
        0: 'technical',
        2: 'discrepancy',
        3: 'contract',
        4: 'inspection',
        13: 'confidential'
}

export const smbcInstance = getLocalStorageInfo()?.defaultLessor?.id === 465;
export const testLessor = getLocalStorageInfo()?.defaultLessor?.id === 13;
export const castleAirInstance = [479, 472].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const halcyonInstance = [483, 484].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const titanAviInstance = getLocalStorageInfo()?.defaultLessor?.id === 480;
export const gaTelesisInstance = [498].includes(getLocalStorageInfo()?.defaultLessor?.id);

